// extracted by mini-css-extract-plugin
export default {"container":"_08M+s","comments":"_8NS15","views":"LsUiu"};